// src/components/games/GameBinding.js

import GameHeader from './GameHeader';
import GameMediaSlider from './GameMediaSlider';
import GamePurchaseBox from './GamePurchaseBox';
import GameDescription from './GameDescription';
import GameInfoBox from './GameInfoBox';
import GameInfoTag from './GameInfoTag';
import GameSystemRequirement from './GameSystemRequirement';
import GameLanguageSupport from './GameLanguageSupport';
import GameRatingBox from './GameRatingBox';
import GameLinks from './GameLinks';

function GameBinding({ game }) {
  if (!game) return null;

  const {
    title,
    capsuleImageUrl,
    shortDescription,
    releaseDate,
    genres,
    tags = [],
    developer,
    publisher,
    rating,
    languages,
    links = {},
    media,
    price,
    discountRate,
    systemRequirement,
    longDescription,
    comingSoon,
  } = game;

  return (
    <div className="bg-[#121212] text-white min-h-screen">
      <div className="max-w-7xl mx-auto">
        <GameHeader title={title} />

        <div className="p-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            <GameMediaSlider media={media} />
            <GamePurchaseBox
              gameName={title}
              price={price}
              discountRate={discountRate}
              backgroundImage={capsuleImageUrl[1]}
              comingSoon={comingSoon}
              purchaseLink={links.purchase}
              tags={game.tags}
            />
            <GameDescription description={longDescription} />
          </div>

          <div className="space-y-4">
            <GameInfoBox
              capsuleImage={capsuleImageUrl[0]}
              description={shortDescription}
              releaseDate={releaseDate}
              genre={Array.isArray(genres) ? genres.join(', ') : genres || ''}
              developer={developer}
              publisher={publisher}
              rating={rating}
            />
            <GameInfoTag tags={tags} />
            <GameRatingBox rating={rating} />
            <GameLanguageSupport supportedLanguages={languages || []} />
            <GameSystemRequirement
              requirements={systemRequirement || { minimum: {}, recommended: {} }}
            />
            <GameLinks links={links || {}} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameBinding;
